// src/pages/ProductDetailPage.jsx
import React, { useState, useCallback, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

const ProductDetailPage = ({ addToCart }) => {
  const { productId } = useParams();

  // This array represents your product database.
  const allProducts = [
    // Extracted from courses.html
    {
      productId: "463",
      title: "100 Days of JavaScript with CodeKata",
      link: "https://slpe-edu.com/product/100-days-of-javascript-with-codekata/",
      image: "images/jsimage.png",
      category: "Courses",
      price: "39000.00",
    },
    {
      productId: "465",
      title: "3ds Max and V-ray – Advanced",
      link: "https://slpe-edu.com/product/3ds-max-and-v-ray-advanced/",
      image: "images/vrayadvance.jpg",
      category: "Courses",
      price: "49999.00",
    },
    {
      productId: "467",
      title: "3ds Max and V-ray – Expert",
      link: "https://slpe-edu.com/product/3ds-max-and-v-ray-expert/",
      image: "images/maxrayexpert.jpg",
      category: "Courses",
      price: "34999.00",
    },
    {
      productId: "516",
      title: "Adobe Firefly",
      link: "https://slpe-edu.com/product/adobe-firefly/",
      image: "images/adobfireflynew.jpg",
      category: "Courses",
      price: "9999.00",
    },
    {
      productId: "518",
      title: "Adobe Illustrator Foundations",
      link: "https://slpe-edu.com/product/adobe-illustrator-foundations/",
      image: "images/adobeillustratorfoundations.jpg",
      category: "Courses",
      price: "4899.00",
    },
    {
      productId: "520",
      title: "Adobe Photoshop",
      link: "https://slpe-edu.com/product/adobe-photoshop/",
      image: "images/adobephotoshopenglish.jpg",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "522",
      title: "Advanced Business Finance",
      link: "https://slpe-edu.com/product/advanced-business-finance/",
      image: "images/advancedbusinessfinance.jpg",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "527",
      title: "Advanced Cyber security",
      link: "https://slpe-edu.com/product/advanced-cyber-security/",
      image: "images/advancecybersecurity.jpg",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "524",
      title: "Advanced Cyber Security and Ethical Hacking",
      link: "https://slpe-edu.com/product/advanced-cyber-security-and-ethical-hacking/",
      image: "images/cyber_security_advanced_english.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "529",
      title: "Advanced Data Visualization using Power BI",
      link: "https://slpe-edu.com/product/advanced-data-visualization-using-power-bi/",
      image: "images/advanceddatavisualisationusingpowerbienglish.avif",
      category: "Courses",
      price: "22999.00",
    },
    {
      productId: "531",
      title: "Advanced Data Visualization using Power BI in…",
      link: "https://slpe-edu.com/product/advanced-data-visualization-using-power-bi-in/",
      image: "images/advanceddatavisualizationusingpowerbitamil.avif",
      category: "Courses",
      price: "9999.00",
    },
    {
      productId: "533",
      title: "Advanced Ethical Hacking",
      link: "https://slpe-edu.com/product/advanced-ethical-hacking/",
      image: "images/ethical_ad_en.avif",
      category: "Courses",
      price: "24999.00",
    },
    {
      productId: "535",
      title: "Advanced Ethical Hacking", // Duplicate title, consider unique ID for products
      link: "https://slpe-edu.com/product/advanced-ethical-hacking-2/",
      image: "images/ethicalhackingadvancedtamiltamil.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "537",
      title: "Advanced JavaScript",
      link: "https://slpe-edu.com/product/advanced-javascript/",
      image: "images/advancedjavascriptenglish.avif",
      category: "Courses",
      price: "6000.00",
    },
    {
      productId: "539",
      title: "Advanced RPA",
      link: "https://slpe-edu.com/product/advanced-rpa/",
      image: "images/advancedrpaenglish.avif",
      category: "Courses",
      price: "46999.00",
    },
    {
      productId: "541",
      title: "Advanced RPA: Hands-On Projects",
      link: "https://slpe-edu.com/product/advanced-rpa-hands-on-projects/",
      image: "images/advancedrpaprojectcourseenglish.avif",
      category: "Courses",
      price: "29999.00",
    },
    {
      productId: "543",
      title: "Advanced Selenium with Java",
      link: "https://slpe-edu.com/product/advanced-selenium-with-java/",
      image: "images/seleniumAdvancedEng.avif",
      category: "Courses",
      price: "19999.00",
    },
    {
      productId: "545",
      title: "Advanced Verification and UVM",
      link: "https://slpe-edu.com/product/advanced-verification-and-uvm/",
      image: "images/advancedverificationanduvm.avif",
      category: "Courses",
      price: "39999.00",
    },
    {
      productId: "547",
      title: "Agile Fundamentals",
      link: "https://slpe-edu.com/product/agile-fundamentals/",
      image: "images/agileenglish.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "551",
      title: "Agile Fundamentals", // Duplicate title
      link: "https://slpe-edu.com/product/agile-fundamentals-2/",
      image: "images/agilefundamentalshindihindi-1.avif",
      category: "Courses",
      price: "36999.00",
    },
    {
      productId: "549",
      title: "Agile Fundamentals in Hindi",
      link: "https://slpe-edu.com/product/agile-fundamentals-in-hindi/",
      image: "images/agilefundamentalshindihindi.avif",
      category: "Courses",
      price: "42999.00",
    },
    {
      productId: "553",
      title: "Agile Transformation Management",
      link: "https://slpe-edu.com/product/agile-transformation-management/",
      image: "images/agiletransformationmanagement.avif",
      category: "Courses",
      price: "19999.00",
    },
    {
      productId: "469",
      title: "AI Fundamentals",
      link: "https://slpe-edu.com/product/ai-fundamentals/",
      image: "images/aifundamentalsenglish.avif",
      category: "Courses",
      price: "9999.00",
    },
    {
      productId: "471",
      title: "AI Fundamentals in French",
      link: "https://slpe-edu.com/product/ai-fundamentals-in-french/",
      image: "images/aifundamentalsinfrench-1.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "555",
      title: "Ajax",
      link: "https://slpe-edu.com/product/ajax/",
      image: "images/ajaxenglish.avif",
      category: "Courses",
      price: "23999.00",
    },
    {
      productId: "557",
      title: "Altium",
      link: "https://slpe-edu.com/product/altium/",
      image: "images/altium.avif",
      category: "Courses",
      price: "19999.00",
    },
    {
      productId: "559",
      title: "Angular Advanced",
      link: "https://slpe-edu.com/product/angular-advanced/",
      image: "images/angularadvanced.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "561",
      title: "Angular Basics",
      link: "https://slpe-edu.com/product/angular-basics/",
      image: "images/angularbasics.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "563",
      title: "Angular Unit Testing",
      link: "https://slpe-edu.com/product/angular-unit-testing/",
      image: "images/angular.avif",
      category: "Courses",
      price: "46999.00",
    },
    {
      productId: "565",
      title: "Apache Cassandra With Python",
      link: "https://slpe-edu.com/product/apache-cassandra-with-python/",
      image: "images/python-1.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "567",
      title: "Application Development Using Microservices a…",
      link: "https://slpe-edu.com/product/application-development-using-microservices-a/",
      image:
        "images/applicationdevelopmentusingmicroservicesserverlessenglish.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "569",
      title: "Application Development using Microservices a…", // Duplicate title
      link: "https://slpe-edu.com/product/application-development-using-microservices-a-2/",
      image: "images/applicationdevelopmentmicrostamil.avif",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "571",
      title: "Applied NLP Project",
      link: "https://slpe-edu.com/product/applied-nlp-project/",
      image: "images/appliednlpproject.avif",
      category: "Courses",
      price: "38999.00",
    },
    {
      productId: "573",
      title: "Aptitude",
      link: "https://slpe-edu.com/product/aptitude/",
      image: "images/aptitude.avif",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "575",
      title: "Architectural Definition (ISA)",
      link: "https://slpe-edu.com/product/architectural-definition-isa/",
      image: "images/architecturaldefinitionisa.avif",
      category: "Courses",
      price: "7899.00",
    },
    {
      productId: "577",
      title: "Arduino",
      link: "https://slpe-edu.com/product/arduino/",
      image: "images/arduinoenglish.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "579",
      title: "Arduino Electronics in Tamil",
      link: "https://slpe-edu.com/product/arduino-electronics-in-tamil/",
      image: "images/arduinoelectronicstamiltamil.avif",
      category: "Courses",
      price: "9999.00",
    },
    {
      productId: "581",
      title: "Art of Electronics: Analog Electronics Part …",
      link: "https://slpe-edu.com/product/art-of-electronics-analog-electronics-part/",
      image: "images/artofelectronicspart2english.avif",
      category: "Courses",
      price: "22399.00",
    },
    {
      productId: "583",
      title: "Art of Electronics: Analog Electronics Part 1",
      link: "https://slpe-edu.com/product/art-of-electronics-analog-electronics-part-1/",
      image:
        "images/artofelectronicsanalogelectronicspart1semiconductordiodesenglish.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "585",
      title: "Art of Electronics: Digital Electronics Part …",
      link: "https://slpe-edu.com/product/art-of-electronics-digital-electronics-part/",
      image: "images/artofelectronicsdigitalelectronicspart1.avif",
      category: "Courses",
      price: "18999.00",
    },
    {
      productId: "587",
      title: "Art of Electronics: Digital Electronics Part …", // Duplicate title
      link: "https://slpe-edu.com/product/art-of-electronics-digital-electronics-part-2/",
      image: "images/artofelectronicsdigitalelectronicspart2.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "476",
      title: "ASIC Verification",
      link: "https://slpe-edu.com/product/asic-verification/",
      image: "images/asicverification.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "589",
      title: "AutoCAD Mechanical",
      link: "https://slpe-edu.com/product/autocad-mechanical/",
      image: "images/autocadmechanicalenglish.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "591",
      title: "Autodesk Inventor for Professional",
      link: "https://slpe-edu.com/product/autodesk-inventor-for-professional/",
      image: "images/autodeskinventorprofessionalenglish.avif",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "593",
      title: "Automating AWS with Python and Boto3",
      link: "https://slpe-edu.com/product/automating-aws-with-python-and-boto3/",
      image: "images/automatingawswithpythonandboto3english.avif",
      category: "Courses",
      price: "45999.00",
    },
    {
      productId: "478",
      title: "AWS Account, Navigation & Instances",
      link: "https://slpe-edu.com/product/aws-account-navigation-instances/",
      image: "images/awsaccountnavigationinstances.avif",
      category: "Courses",
      price: "39999.00",
    },
    {
      productId: "480",
      title: "AWS Billing,Key Management & Security",
      link: "https://slpe-edu.com/product/aws-billingkey-management-security/",
      image: "images/awsbillingkeymanagementsecurity.avif",
      category: "Courses",
      price: "9999.00",
    },
    {
      productId: "482",
      title: "AWS CloudFormation",
      link: "https://slpe-edu.com/product/aws-cloudformation/",
      image: "images/aws.avif",
      category: "Courses",
      price: "9999.00",
    },
    {
      productId: "484",
      title: "AWS Fundamentals",
      link: "https://slpe-edu.com/product/aws-fundamentals/",
      image: "images/awsfundamentalsinfrench.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "486",
      title: "AWS Fundamentals", // Duplicate title
      link: "https://slpe-edu.com/product/aws-fundamentals-2/",
      image: "images/awsfundamentalsintamiltamil.avif",
      category: "Courses",
      price: "14999.00",
    },
    {
      productId: "488",
      title: "AWS Fundamentals in Arabic",
      link: "https://slpe-edu.com/product/aws-fundamentals-in-arabic/",
      image: "images/awsfundamentalsinfrench.avif",
      category: "Courses",
      price: "48999.00",
    },
    {
      productId: "489",
      title: "AWS Infrastructure – Advanced",
      link: "https://slpe-edu.com/product/aws-infrastructure-advanced/",
      image: "images/awsinfrastructureadvancedenglish.avif",
      category: "Courses",
      price: "0.00", // Price missing in original HTML, set to 0
    },
    {
      productId: "492",
      title: "AWS Infrastructure – Intermediate",
      link: "https://slpe-edu.com/product/aws-infrastructure-intermediate/",
      image: "images/awsinfrastructureintermediateenglish.avif",
      category: "Courses",
      price: "43999.00",
    },
    {
      productId: "494",
      title: "AWS Infrastructure for Beginners",
      link: "https://slpe-edu.com/product/aws-infrastructure-for-beginners/",
      image: "images/awsinfrastructurebeginnersenglish.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "497",
      title: "AWS Infrastructure for Beginners", // Duplicate title
      link: "https://slpe-edu.com/product/aws-infrastructure-for-beginners-2/",
      image: "images/awsinfrastructureforbeginnersintamil.avif",
      category: "Courses",
      price: "39999.00",
    },
    {
      productId: "499",
      title: "AWS Lambda",
      link: "https://slpe-edu.com/product/aws-lambda/",
      image: "images/awsinfrastructureforbeginnersintamil-1.avif",
      category: "Courses",
      price: "29999.00",
    },
    {
      productId: "501",
      title: "AWS Load Balance",
      link: "https://slpe-edu.com/product/aws-load-balance/",
      image: "images/awsloadbalance.avif",
      category: "Courses",
      price: "39999.00",
    },
    {
      productId: "503",
      title: "AWS Security and Management",
      link: "https://slpe-edu.com/product/aws-security-and-management/",
      image: "images/awssecurityandmanagementenglish.avif",
      category: "Courses",
      price: "42399.00",
    },
    {
      productId: "505",
      title: "AZ – 104",
      link: "https://slpe-edu.com/product/az-104/",
      image: "images/az104english.avif",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "507",
      title: "AZ 500: Data and App Security",
      link: "https://slpe-edu.com/product/az-500-data-and-app-security/",
      image: "images/az500dataandappsecurityenglish.avif",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "509",
      title: "AZ 500: Identity and Access Management",
      link: "https://slpe-edu.com/product/az-500-identity-and-access-management/",
      image: "images/microsoftazuresecuritytechnologiesaz500partienglish.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "511",
      title: "AZ 500: Platform Security",
      link: "https://slpe-edu.com/product/az-500-platform-security/",
      image: "images/az500platformsecurityenglish.avif",
      category: "Courses",
      price: "44999.00",
    },
    {
      productId: "513",
      title: "AZ 500: Security Operations",
      link: "https://slpe-edu.com/product/az-500-security-operations/",
      image: "images/az500securityoperationsenglish.avif",
      category: "Courses",
      price: "29999.00",
    },
    {
      productId: "595",
      title: "Azure DevOps",
      link: "https://slpe-edu.com/product/azure-devops/",
      image: "images/azuredevopsenglish.avif",
      category: "Courses",
      price: "45999.00",
    },
    {
      productId: "597",
      title: "Azure DevOps in Hindi",
      link: "https://slpe-edu.com/product/azure-devops-in-hindi/",
      image: "images/azuredevopsenglish-1.avif",
      category: "Courses",
      price: "45999.00",
    },
    {
      productId: "599",
      title: "Azure DevOps in Odia",
      link: "https://slpe-edu.com/product/azure-devops-in-odia/",
      image: "images/azuredevopsodiaodia.avif",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "602",
      title: "Azure DevOps in Telugu",
      link: "https://slpe-edu.com/product/azure-devops-in-telugu/",
      image: "images/azuredevopstelugutelugu.avif",
      category: "Courses",
      price: "56999.00",
    },
    {
      productId: "445",
      title: "Azure Solution Architect Part – 1",
      link: "https://slpe-edu.com/product/azure-solution-architect-part-1/",
      image: "images/azuresolutionarchitectpart1.avif",
      category: "Courses",
      price: "14599.00",
    },
    {
      productId: "604",
      title: "Azure Synapse Analytics",
      link: "https://slpe-edu.com/product/azure-synapse-analytics/",
      image: "images/azuresynapseanalytics.avif",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "606",
      title: "Balsamiq",
      link: "https://slpe-edu.com/product/balsamiq/",
      image: "images/balsamiq.avif",
      category: "Courses",
      price: "0.00", // Price missing in original HTML, set to 0
    },
    {
      productId: "610",
      title: "Basics of AWS cloud computing",
      link: "https://slpe-edu.com/product/basics-of-aws-cloud-computing/",
      image: "images/basicsofawscloudcomputing.avif",
      category: "Courses",
      price: "10999.00",
    },
    {
      productId: "608",
      title: "Basics Of Computer",
      link: "https://slpe-edu.com/product/basics-of-computer/",
      image: "images/basicsofcomputer.avif",
      category: "Courses",
      price: "45999.00",
    },
    {
      productId: "612",
      title: "Basics of Computer in Bengali",
      link: "https://slpe-edu.com/product/basics-of-computer-in-bengali/",
      image: "images/basicsofcomputerbengali.avif",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "614",
      title: "Basics of Computer in Gujarati",
      link: "https://slpe-edu.com/product/basics-of-computer-in-gujarati/",
      image: "images/basicsofcomputerbengali.avif", // Same image as Bengali
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "615",
      title: "Basics of PostgreSQL",
      link: "https://slpe-edu.com/product/basics-of-postgresql/",
      image: "images/basicsofpostgresql.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "617",
      title: "Basics of Quantum Computing",
      link: "https://slpe-edu.com/product/basics-of-quantum-computing/",
      image: "images/physicsforquantumcomputingenglish.avif",
      category: "Courses",
      price: "39999.00",
    },
    {
      productId: "619",
      title: "Become an IOS Developer from scratch",
      link: "https://slpe-edu.com/product/become-an-ios-developer-from-scratch/",
      image: "images/becomeaniosdeveloperfromscratch.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "621",
      title: "Blockchain",
      link: "https://slpe-edu.com/product/blockchain/",
      image: "images/blockchain-1.avif",
      category: "Courses",
      price: "45999.00",
    },
    {
      productId: "625",
      title: "Blockchain in Hindi",
      link: "https://slpe-edu.com/product/blockchain-in-hindi/",
      image: "images/blockchaintechnology.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "623",
      title: "Blockchain Technology",
      link: "https://slpe-edu.com/product/blockchain-technology/",
      image: "images/blockchaintechnology.avif",
      category: "Courses",
      price: "29999.00",
    },
    {
      productId: "626",
      title: "Bootstrap",
      link: "https://slpe-edu.com/product/bootstrap/",
      image: "images/bootstrapenglish.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "628",
      title: "Bootstrap Arabic",
      link: "https://slpe-edu.com/product/bootstrap-arabic/",
      image: "images/bootstraparabic.avif",
      category: "Courses",
      price: "29999.00",
    },
    {
      productId: "630",
      title: "Bootstrap in French",
      link: "https://slpe-edu.com/product/bootstrap-in-french/",
      image: "images/bootstrapfrench.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "632",
      title: "Bootstrap in Marathi",
      link: "https://slpe-edu.com/product/bootstrap-in-marathi/",
      image: "images/bootstrapmarathimarathi.avif",
      category: "Courses",
      price: "6999.00",
    },
    {
      productId: "634",
      title: "Bootstrap in Telugu",
      link: "https://slpe-edu.com/product/bootstrap-in-telugu/",
      image: "images/bootstraptelugutelugu.avif",
      category: "Courses",
      price: "11999.00",
    },
    {
      productId: "637",
      title: "Bootstrap in Vietnamese",
      link: "https://slpe-edu.com/product/bootstrap-in-vietnamese/",
      image: "images/bootstraparabic.avif", // Same as Bootstrap Arabic
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "640",
      title: "Brand Identity Design",
      link: "https://slpe-edu.com/product/brand-identity-design/",
      image: "images/brandidentitydesign.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "642",
      title: "Building REST APIs using .NET Core",
      link: "https://slpe-edu.com/product/building-rest-apis-using-net-core/",
      image: "images/microcontroller.avif",
      category: "Courses",
      price: "29999.00",
    },
    {
      productId: "644",
      title: "Building REST APIs using .NET Core", // Duplicate title
      link: "https://slpe-edu.com/product/building-rest-apis-using-net-core-2/",
      image: "images/microcontroller.avif", // Same image
      category: "Courses",
      price: "46999.00",
    },
    {
      productId: "645",
      title: "Building RESTful APIs with Redis and Python",
      link: "https://slpe-edu.com/product/building-restful-apis-with-redis-and-python/",
      image: "images/microcontroller.avif", // Same image
      category: "Courses",
      price: "39999.00",
    },
    {
      productId: "648",
      title: "Business Communication",
      link: "https://slpe-edu.com/product/business-communication/",
      image: "images/businesscommunicationenglish.avif",
      category: "Courses",
      price: "7999.00",
    },
    {
      productId: "650",
      title: "Business Finance",
      link: "https://slpe-edu.com/product/business-finance/",
      image: "images/businesscommunicationenglish.avif", // Same image
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "651",
      title: "Business Intelligence Analyst",
      link: "https://slpe-edu.com/product/business-intelligence-analyst/",
      image: "images/businessintelligenceanalystenglish.avif",
      category: "Courses",
      price: "20999.00",
    },
    {
      productId: "447",
      title: "Introduction to FPGA architectures",
      link: "https://slpe-edu.com/product/introduction-to-fpga-architectures/",
      image: "images/introductiontofpgaarchitectures.avif",
      category: "Courses",
      price: "39999.00",
    },
    {
      productId: "449",
      title: "Meta Ads",
      link: "https://slpe-edu.com/product/meta-ads/",
      image: "images/metaads.avif",
      category: "Courses",
      price: "19999.00",
    },
    {
      productId: "451",
      title: "Node.js",
      link: "https://slpe-edu.com/product/node-js/",
      image: "images/nodejsenglish.avif",
      category: "Courses",
      price: "25999.00",
    },
    {
      productId: "453",
      title: "Python Zero to Hero",
      link: "https://slpe-edu.com/product/python-zero-to-hero/",
      image: "images/python.avif",
      category: "Courses",
      price: "29999.00",
    },
    {
      productId: "457",
      title: "Time Series Analysis and Forecasting",
      link: "https://slpe-edu.com/product/time-series-analysis-and-forecasting/",
      image: "images/timeseriesanalysisandforecasting.avif",
      category: "Courses",
      price: "30999.00",
    },
    {
      productId: "459",
      title: "Web Development with Python Flask",
      link: "https://slpe-edu.com/product/web-development-with-python-flask/",
      image: "images/pythonflasktamil.avif",
      category: "Courses",
      price: "5999.00",
    },
    {
      productId: "461",
      title: "WordPress",
      link: "https://slpe-edu.com/product/wordpress/",
      image: "images/wordpresshindi.avif",
      category: "Courses",
      price: "0.00", // Price missing in original HTML, set to 0
    },
  ];

  const relatedProducts = [
    {
      productId: "469",
      title: "AI Fundamentals",
      link: "https://slpe-edu.com/product/ai-fundamentals/",
      image: "images/aifundamentalsenglish.avif",
      price: "99999.00",
      category: "Courses",
    },
    {
      productId: "480",
      title: "AWS Billing,Key Management & Security",
      link: "https://slpe-edu.com/product/aws-billingkey-management-security/",
      image: "images/awsbillingkeymanagementsecurity.avif",
      price: "98999.00",
      category: "Courses",
    },
    {
      productId: "486",
      title: "AWS Fundamentals",
      link: "https://slpe-edu.com/product/aws-fundamentals-2/",
      image: "images/awsfundamentalsintamiltamil.avif",
      price: "14999.00",
      category: "Courses",
    },
    {
      productId: "494",
      title: "AWS Infrastructure for Beginners",
      link: "https://slpe-edu.com/product/aws-infrastructure-for-beginners/",
      image: "images/awsinfrastructurebeginnersenglish.avif",
      price: "59999.00",
      category: "Courses",
    },
    {
      productId: "499",
      title: "AWS Lambda",
      link: "https://slpe-edu.com/product/aws-lambda/",
      image: "images/awsinfrastructureforbeginnersintamil-1.avif",
      price: "29999.00",
      category: "Courses",
    },
    {
      productId: "503",
      title: "AWS Security and Management",
      link: "https://slpe-edu.com/product/aws-security-and-management/",
      image: "images/awssecurityandmanagementenglish.avif",
      price: "49999.00",
      category: "Courses",
    },
    {
      productId: "507",
      title: "AZ 500: Data and App Security",
      link: "https://slpe-edu.com/product/az-500-data-and-app-security/",
      image: "images/az500dataandappsecurityenglish.avif",
      price: "74999.00",
      category: "Courses",
    },
    {
      productId: "457",
      title: "Time Series Analysis and Forecasting",
      link: "https://slpe-edu.com/product/time-series-analysis-and-forecasting/",
      image: "images/timeseriesanalysisandforecasting.avif",
      price: "89999.00",
      category: "Courses",
    },
  ];

  const [quantity, setQuantity] = useState(1);
  const [product, setProduct] = useState(null); // State to hold the found product

 
  // Effect to find the product when productId changes
  useEffect(() => {
    const foundProduct = allProducts.find((p) => p.productId === productId);
    setProduct(foundProduct);
  }, []);

  const handleQuantityChange = useCallback((delta) => {
    setQuantity((prevQty) => Math.max(1, prevQty + delta));
  }, []);

  const handleAddToCart = useCallback(() => {
    if (product) {
      // Ensure product is not null before adding to cart
      addToCart({ ...product, quantity: quantity });
    }
  }, [addToCart, product, quantity]);

  // If product is not found, display a message
  if (!product) {
    return (
      <div className="wd-page-content main-page-wrapper">
        <main
          className="wd-content-layout content-layout-wrapper wd-builder-off"
          role="main"
        >
          <div className="wd-content-area site-content">
            <div className="container">
              <p>Product not found.</p>
              <Link to="/courses">Back to all courses</Link>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <>
      {/* Page Content */}
      <div className="wd-page-content main-page-wrapper">
        <main
          className="wd-content-layout content-layout-wrapper wd-builder-off"
          role="main"
        >
          <div className="wd-content-area site-content">
            <div
              id={`product-${product.productId}`}
              className="single-product-page single-product-content product-design-default tabs-location-standard tabs-type-tabs meta-location-add_to_cart reviews-location-tabs product-no-bg product type-product post-467 status-publish first instock product_cat-courses has-post-thumbnail shipping-taxable purchasable product-type-simple"
            >
              <div className="container">
                <div className="woocommerce-notices-wrapper"></div>
                <div className="product-image-summary-wrap">
                  <div className="product-image-summary">
                    <div
                      className="product-image-summary-inner wd-grid-g"
                      style={{
                        "--wd-col-lg": 12,
                        "--wd-gap-lg": "30px",
                        "--wd-gap-sm": "20px",
                      }}
                    >
                      {/* Product Images */}
                      <div
                        className="product-images wd-grid-col"
                        style={{
                          "--wd-col-lg": 6,
                          "--wd-col-md": 6,
                          "--wd-col-sm": 12,
                        }}
                      >
                        <div className="woocommerce-product-gallery woocommerce-product-gallery--with-images woocommerce-product-gallery--columns-4 images  thumbs-position-left wd-thumbs-wrap images image-action-zoom">
                          <div className="wd-carousel-container wd-gallery-images">
                            <div className="wd-carousel-inner">
                              <figure
                                className="woocommerce-product-gallery__wrapper wd-carousel wd-grid"
                                style={{
                                  "--wd-col-lg": 1,
                                  "--wd-col-md": 1,
                                  "--wd-col-sm": 1,
                                }}
                              >
                                <div className="wd-carousel-wrap">
                                  <div className="wd-carousel-item">
                                    <figure
                                      data-thumb={`/${product.image}`}
                                      className="woocommerce-product-gallery__image"
                                    >
                                      <a
                                        data-elementor-open-lightbox="no"
                                        href={`/${product.image}`}
                                      >
                                        <img
                                     
                                          src={`/${product.image}`}
                                          className="wp-post-image wp-post-image"
                                          alt={product.title}
                                          title={product.title}
                                          decoding="async"
                                        />
                                      </a>
                                    </figure>
                                  </div>
                                </div>
                              </figure>
                              <div className="wd-nav-arrows wd-pos-sep wd-hover-1 wd-custom-style wd-icon-1">
                                <div className="wd-btn-arrow wd-prev wd-disabled">
                                  <div className="wd-arrow-inner"></div>
                                </div>
                                <div className="wd-btn-arrow wd-next">
                                  <div className="wd-arrow-inner"></div>
                                </div>
                              </div>
                              <div className="product-additional-galleries">
                                <div className="wd-show-product-gallery-wrap wd-action-btn wd-style-icon-bg-text wd-gallery-btn">
                                  <Link
                                    to="#"
                                    rel="nofollow"
                                    className="woodmart-show-product-gallery"
                                  >
                                    <span>Click to enlarge</span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="wd-carousel-container wd-gallery-thumb">
                            <div className="wd-carousel-inner">
                              <div
                                className="wd-carousel wd-grid"
                                style={{
                                  "--wd-col-lg": 3,
                                  "--wd-col-md": 4,
                                  "--wd-col-sm": 3,
                                }}
                              >
                                <div className="wd-carousel-wrap"></div>
                              </div>
                              <div className="wd-nav-arrows wd-thumb-nav wd-custom-style wd-pos-sep wd-icon-1">
                                <div className="wd-btn-arrow wd-prev wd-disabled">
                                  <div className="wd-arrow-inner"></div>
                                </div>
                                <div className="wd-btn-arrow wd-next">
                                  <div className="wd-arrow-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Product Summary */}
                      <div
                        className="summary entry-summary text-left wd-grid-col"
                        style={{
                          "--wd-col-lg": 6,
                          "--wd-col-md": 6,
                          "--wd-col-sm": 12,
                        }}
                      >
                        <div className="summary-inner wd-set-mb reset-last-child">
                          <div className="single-breadcrumbs-wrapper wd-grid-f">
                            <nav
                              className="wd-breadcrumbs woocommerce-breadcrumb"
                              aria-label="Breadcrumb"
                            >
                              <span typeof="v:Breadcrumb">
                                <Link to="/" rel="v:url" property="v:title">
                                  Home
                                </Link>
                              </span>
                              <span className="wd-delimiter"></span>
                              <span
                                typeof="v:Breadcrumb"
                                className="wd-last-link"
                              >
                                <Link
                                  to="/courses"
                                  rel="v:url"
                                  property="v:title"
                                >
                                  Courses
                                </Link>
                              </span>
                              <span className="wd-delimiter"></span>
                              <span className="wd-last">{product.title}</span>
                            </nav>
                            {/* Product Navigation (Prev/Next) - simplified for React */}
                            <div className="wd-products-nav">
                              <div className="wd-event-hover">
                                <Link
                                  className="wd-product-nav-btn wd-btn-prev"
                                  to="#"
                                  aria-label="Previous product"
                                ></Link>
                                <div className="wd-dropdown">
                                  {/* Placeholder for previous product */}
                                </div>
                              </div>
                              <Link
                                to="/courses"
                                className="wd-product-nav-btn wd-btn-back wd-tooltip"
                              >
                                <span>Back to products</span>
                              </Link>
                              <div className="wd-event-hover">
                                <Link
                                  className="wd-product-nav-btn wd-btn-next"
                                  to="#"
                                  aria-label="Next product"
                                ></Link>
                                <div className="wd-dropdown">
                                  {/* Placeholder for next product */}
                                </div>
                              </div>
                            </div>
                          </div>

                          <h1 className="product_title entry-title wd-entities-title">
                            {product.title}
                          </h1>
                          <p className="price">
                            <span className="woocommerce-Price-amount amount">
                              <bdi>
                                <span className="woocommerce-Price-currencySymbol">
                                  ₹
                                </span>
                                {parseFloat(product.price).toFixed(2)}
                              </bdi>
                            </span>
                          </p>

                          {/* Add to cart form */}
                          <div className="cart">
                            <div className="quantity">
                              <button
                                type="button"
                                value="-"
                                className="minus btn"
                                onClick={() => handleQuantityChange(-1)}
                              >
                                -
                              </button>
                              <label
                                className="screen-reader-text"
                                htmlFor="quantity_product"
                              >
                                {product.title} quantity
                              </label>
                              <input
                                type="number"
                                id="quantity_product"
                                className="input-text qty text"
                                value={quantity}
                                aria-label="Product quantity"
                                min="1"
                                name="quantity"
                                step="1"
                                inputMode="numeric"
                                autoComplete="off"
                                onChange={(e) =>
                                  setQuantity(parseInt(e.target.value) || 1)
                                }
                              />
                              <button
                                type="button"
                                value="+"
                                className="plus btn"
                                onClick={() => handleQuantityChange(1)}
                              >
                                +
                              </button>
                            </div>
                            <button
                              type="submit"
                              name="add-to-cart"
                              value={product.productId}
                              className="single_add_to_cart_button button alt"
                              onClick={handleAddToCart}
                            >
                              Add to cart
                            </button>
                          </div>

                          <div className="product_meta">
                            <span className="posted_in">
                              <span className="meta-label">Category:</span>
                              <Link to="/courses" rel="tag">
                                {product.category}
                              </Link>
                            </span>
                          </div>

                          {/* Social Share Icons */}
                          <div className="wd-social-icons wd-style-default wd-size-small social-share wd-shape-circle product-share wd-layout-inline text-left">
                            <span className="wd-label share-title">Share:</span>
                            <Link
                              rel="noopener noreferrer nofollow"
                              to={``}
                              target="_blank"
                              className="wd-social-icon social-facebook"
                              aria-label="Facebook social link"
                            >
                              <span className="wd-icon"></span>
                            </Link>
                            <Link
                              rel="noopener noreferrer nofollow"
                              to={``}
                              target="_blank"
                              className="wd-social-icon social-twitter"
                              aria-label="X social link"
                            >
                              <span className="wd-icon"></span>
                            </Link>
                            <a
                              rel="noopener noreferrer nofollow"
                              href={``}
                              target="_blank"
                              className="wd-social-icon social-pinterest"
                              aria-label="Pinterest social link"
                            >
                              <span className="wd-icon"></span>
                            </a>
                            <a
                              rel="noopener noreferrer nofollow"
                              href={``}
                              target="_blank"
                              className="wd-social-icon social-linkedin"
                              aria-label="Linkedin social link"
                            >
                              <span className="wd-icon"></span>
                            </a>
                            <a
                              rel="noopener noreferrer nofollow"
                              href={``}
                              target="_blank"
                              className="wd-social-icon social-tg"
                              aria-label="Telegram social link"
                            >
                              <span className="wd-icon"></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Related Products Section */}
            <div className="container related-and-upsells">
              <div
                id="carousel-212"
                className="wd-carousel-container related-products with-title wd-products-element wd-products products title-line-one"
              >
                <h2 className="wd-el-title title slider-title element-title">
                  <span>Related products</span>
                </h2>
                <div className="wd-carousel-inner">
                  <div
                    className="wd-carousel wd-grid"
                    style={{
                      "--wd-col-lg": 4,
                      "--wd-col-md": 4,
                      "--wd-col-sm": 2,
                      "--wd-gap-lg": "20px",
                      "--wd-gap-sm": "10px",
                    }}
                  >
                    <div
                      className="wd-carousel-wrap"
                      style={{ display: "flex", gap: "20px" }}
                    >
                      {relatedProducts.map((relatedProduct) => (
                        <div
                          className="wd-carousel-item"
                          key={relatedProduct.productId}
                        >
                          <div
                            className="wd-product wd-hover-fw-button wd-hover-with-fade wd-fade-off product-grid-item product type-product post-469 status-publish last instock product_cat-courses has-post-thumbnail shipping-taxable purchasable product-type-simple"
                            data-loop={relatedProduct.productId}
                            data-id={relatedProduct.productId}
                          >
                            <div className="product-wrapper">
                              <div className="content-product-imagin"></div>
                              <div className="product-element-top wd-quick-shop">
                                <Link
                                  to={relatedProduct.link}
                                  className="product-image-link"
                                >
                                  <img
                                    loading="lazy"
                                    width="1"
                                    height="1"
                                    src={`/${relatedProduct.image}`}
                                    className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                                    alt={relatedProduct.title}
                                    decoding="async"
                                  />
                                </Link>
                                <div className="wd-buttons wd-pos-r-t"></div>
                              </div>
                              <div className="product-element-bottom">
                                <h3 className="wd-entities-title">
                                  <Link to={relatedProduct.link}>
                                    {relatedProduct.title}
                                  </Link>
                                </h3>
                                <div className="wd-product-cats">
                                  <Link to="/courses" rel="tag">
                                    {relatedProduct.category}
                                  </Link>
                                </div>
                                <div className="wrap-price">
                                  <span className="price">
                                    <span className="woocommerce-Price-amount amount">
                                      <bdi>
                                        <span className="woocommerce-Price-currencySymbol">
                                          ₹
                                        </span>
                                        {parseFloat(
                                          relatedProduct.price
                                        ).toFixed(2)}
                                      </bdi>
                                    </span>
                                  </span>
                                </div>
                                <div className="wd-add-btn wd-add-btn-replace">
                                  <button
                                    className="button product_type_simple add_to_cart_button ajax_add_to_cart add-to-cart-loop"
                                    onClick={() => addToCart(relatedProduct)}
                                    aria-label={`Add to cart: “${relatedProduct.title}”`}
                                  >
                                    <span>Add to cart</span>
                                  </button>
                                  <span className="screen-reader-text"></span>
                                </div>
                                <div className="fade-in-block wd-scroll">
                                  <div className="hover-content-wrap">
                                    <div className="hover-content wd-more-desc">
                                      <div className="hover-content-inner wd-more-desc-inner"></div>
                                      <a
                                        href="#"
                                        rel="nofollow"
                                        className="wd-more-desc-btn"
                                        aria-label="Read more description"
                                      ></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="wd-nav-arrows wd-pos-sep wd-hover-1 wd-icon-1">
                    <div className="wd-btn-arrow wd-prev wd-disabled">
                      <div className="wd-arrow-inner"></div>
                    </div>
                    <div className="wd-btn-arrow wd-next">
                      <div className="wd-arrow-inner"></div>
                    </div>
                  </div>
                </div>
                <div className="wd-nav-pagin-wrap text-center wd-style-shape wd-hide-md-sm wd-hide-sm">
                  <ul className="wd-nav-pagin"></ul>
                </div>
              </div>
            </div>
          </div>{" "}
          {/* Closing div for wd-content-area site-content */}
        </main>{" "}
        {/* Closing main for wd-content-layout */}
      </div>{" "}
      {/* Closing div for wd-page-content main-page-wrapper */}
    </>
  );
};

export default ProductDetailPage;
